import { render, staticRenderFns } from "./PoliticPage.vue?vue&type=template&id=38baba32"
import script from "./PoliticPage.vue?vue&type=script&lang=js"
export * from "./PoliticPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports